<template>
  <form class="template-search-form" @submit.prevent="submit">
    <div v-if="showing" class="input-wrapper">
      <button class="bg-transparent border-0 p-0" type="submit">
        <i class="fas fa-search text-secondary"></i>
      </button>
      <input ref="input" v-model="text" type="text" @blur="hide" />
    </div>
    <button v-if="!showing" class="btn" @click="show" type="button">
      <i class="fas fa-search text-secondary"></i>
    </button>
  </form>
</template>

<script>
export default {
  data() {
    return {
      text: this.$route.query.search,
      showing: false
    };
  },
  methods: {
    show() {
      this.showing = true;
      setTimeout(() => {
        this.$refs.input.focus();
      }, 1);
    },
    hide() {
      if (this.showing) {
        setTimeout(() => {
          this.showing = false;
        }, 300);
      }
    },
    submit() {
      this.$router.push({
        name: "feed",
        query: {
          search: this.text
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.template-search-form {
  display: flex;
  align-items: center;

  .input-wrapper {
    background: #202020;
    border-radius: 8px;
    padding: 8px 12px;
    flex-wrap: nowrap;
    display: flex;

    input {
      border: none;
      background: transparent;
      color: white;
      margin-left: 8px;
    }
  }
}
</style>
